<template>
    <CCard>
        <CCardBody>
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <h6>
                            {{ $t("new_provider_description") }}
                        </h6>
                        <br />
                        <CForm
                            ref="formViewGeneral"
                            @submit="submitForm($event, 'viewGeneral')"
                        >
                        <CInput
                            :isValid="
                                checkIfFormValid({
                                    formName: 'viewGeneral',
                                    fieldName: 'name',
                                })
                            "
                            :value.sync="$v.forms.viewGeneral.name.$model"
                            :label="$t('name')"
                            :horizontal="defaultInputConfig.horizontal"
                            :placeholder="$t('enter_the_name')"
                            :invalidFeedback="$t('name_is_required')"
                            size="sm"
                        />
                        <CInput
                            :isValid="
                                checkIfFormValid({
                                    formName: 'viewGeneral',
                                    fieldName: 'cif',
                                })
                            "
                            :value.sync="$v.forms.viewGeneral.cif.$model"
                            :label="$t('cif')"
                            :placeholder="$t('enter_the_cif')"
                            :invalidFeedback="$t('cif_is_required')"
                            :horizontal="defaultInputConfig.horizontal"
                            size="sm"
                        />
                        <CInput
                            :isValid="
                                checkIfFormValid({
                                    formName: 'viewGeneral',
                                    fieldName: 'address',
                                })
                            "
                            :value.sync="$v.forms.viewGeneral.address.$model"
                            :label="$t('address')"
                            :placeholder="$t('enter_the_address')"
                            :invalidFeedback="$t('address_is_required')"
                            :horizontal="defaultInputConfig.horizontal"
                            size="sm"
                        />
                        <CInput
                            :isValid="
                                checkIfFormValid({
                                    formName: 'viewGeneral',
                                    fieldName: 'province',
                                })
                            "
                            :value.sync="$v.forms.viewGeneral.province.$model"
                            :label="$t('province')"
                            :placeholder="$t('enter_the_province')"
                            :invalidFeedback="$t('province_is_required')"
                            :horizontal="defaultInputConfig.horizontal"
                            size="sm"
                        />
                        <CInput
                            :isValid="
                                checkIfFormValid({
                                    formName: 'viewGeneral',
                                    fieldName: 'cp',
                                })
                            "
                            :value.sync="$v.forms.viewGeneral.cp.$model"
                            :label="$t('cp')"
                            :placeholder="$t('enter_the_post_code')"
                            :invalidFeedback="$t('post_code_is_required')"
                            :horizontal="defaultInputConfig.horizontal"
                            size="sm"
                        />
                        <SelectCountry
                            :isValid="
                                checkIfFormValid({
                                    formName: 'viewGeneral',
                                    fieldName: 'country_id',
                                })
                            "
                            :value.sync="$v.forms.viewGeneral.country_id.$model"
                            :label="$t('country')"
                            :placeholder="$t('select_an_option')"
                            :invalidFeedback="$t('country_is_required')"
                            :horizontal="defaultInputConfig.horizontal"
                            size="sm"
                        />
                        <SelectLanguage
                            :isValid="
                                checkIfFormValid({
                                    formName: 'viewGeneral',
                                    fieldName: 'language_id',
                                })
                            "
                            :value.sync="$v.forms.viewGeneral.language_id.$model"
                            :label="$t('language')"
                            :placeholder="$t('select_an_option')"
                            :invalidFeedback="$t('language_is_required')"
                            :horizontal="defaultInputConfig.horizontal"
                            size="sm"
                        />
                        </CForm>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <CCardFooter class="d-flex">
            <ButtonSave
                @click="executeSubmitForm('formViewGeneral')"
                :disabled="forms.viewGeneral._loading"
            />
            <ButtonBack />
        </CCardFooter>
    </CCard>
</template>

<script>
/** Components */
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave";

/** Mixins */
import formMixin from "~/mixins/form";
import { validationMixin } from "vuelidate";

/** Others */
import { required } from "vuelidate/lib/validators";

export default {
    name: "ProviderViewGeneralTab",
    mixins: [validationMixin, formMixin],
    components: {
        SelectCountry,
        SelectLanguage,
        ButtonBack,
        ButtonSave,
    },
    data(){
        return {
            forms: {
                viewGeneral: {
                    name: null,
                    cif: null,
                    address: null,
                    province: null,
                    cp: null,
                    country_id: null,
                    language_id: null,
                    _loading: false,
                },
            },
        }
    },

    validations: {
        forms: {
            viewGeneral: {
                name: {
                    required,
                },
                cif: {
                    required,
                },
                address: {
                    required,
                },
                province: {
                    required,
                },
                cp: {
                    required,
                },
                country_id: {
                    required,
                },
                language_id: {
                    required,
                },
            },
        },
    },
    props: {
        provider:{
            type: Object,
        },
        mode: {
            type: String,
            default: "create",
        },
        loading: Boolean
    },
    methods:{
        async addField() {
            await this.sendForm({
                formName: "viewGeneral",
                url: "/provider_group",
                normalize: true
            });
        },
        async updateField() {
            await this.sendForm({
                formName: "viewGeneral",
                method: "PUT",
                url: "/provider_group/" + this.forms.viewGeneral.uuid,
                normalize: true
            });
        },
        async submitForm(e, formName) {
            e.preventDefault();
            if (this.mode === "edit") {
                await this.updateField();
            } else {
                await this.addField();
            }
            this.$router.go(-1);
        },
    },
    async mounted() {
        this.forms.viewGeneral = {
            ...this.forms.viewGeneral,
            ...this.provider
        };
    },

    
};
</script>

<style>
</style>